<template>
<div class="chapter">
<div class="inner_page">
<h3 class="calibre4">'s ist so ein stiller, heil'ger Tag</h3>
<p class="vers">'s ist so ein stiller, heil'ger Tag,<br class="calibre2"/>
man hört der Zeiten Flügelschlag.</p>
<p class="vers">Der erste Schnee, mit leiser Hand,<br class="calibre2"/>
deckt Anger zu und Heideland;</p>
<p class="vers">er hüllt in lichten Totenschrein<br class="calibre2"/>
des Herbstes düstre Trümmer ein.</p>
<p class="vers">Wär' für der Seele Trümmerfeld<br class="calibre2"/>
doch auch ein solcher Schrein bestellt! <a class="pcalibre pcalibre3 pcalibre1 pcalibre2" id="page25" title="wedi/Konmax"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0010.vue?1aa33834